<template>
<transition name="modal">
<div class="modal-container">
  <div class="modal">
    <div class="modal-dialog" ref="modalDialog">
      <div class="modal-content">
        <div class="modal-header" v-if="showHeader" ref="modalHeader">
          <slot name="header">
            <h2 class="title">{{title}}</h2>
          </slot>
          <button v-if="showTopDismissButton"
              :class="topDismissButtonClass"
              @click="$emit('dismiss')">
            {{topDismissButtonLabel}}
          </button>
        </div>
        <div class="modal-body" :style="{'max-height': modalBodyMaxHeight+'px'}">
          <slot name="body">{{body}}</slot>
        </div>
        <div class="modal-footer" v-if="showFooter" ref="modalFooter">
          <slot name="footer">
            <template v-if="flipBottomButton">
              <button class="btn btn-secondary"
                @click="$emit('dismiss')"
                v-if="showBottomDismissButton">
                {{bottomDismissButtonLabel}}
              </button>
            </template>
            <button class="btn" :class="bottomCloseButtonClass"
                :disabled="shouldCloseButtonDisabled"
                @click="$emit('close')"
                v-if="showBottomCloseButton">
              <i class="fa fa-spinner fa-spin"
                v-show="isCloseButtonBusy"></i>
              <i class="fa" v-if="showBottomCloseButtonIcon"
                :class="bottomCloseButtonIconClass"
                v-show="!isCloseButtonBusy"></i>
              <span v-show="!isCloseButtonBusy">
                {{bottomCloseButtonLabel}}
              </span>
            </button>
            <template v-if="!flipBottomButton">
              <button class="btn btn-secondary"
                @click="$emit('dismiss')"
                v-if="showBottomDismissButton">
                {{bottomDismissButtonLabel}}
              </button>
            </template>
          </slot>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop">
  </div>
</div>
</transition>
</template>

<script>
export default {
  name: 'modal',
  props: {
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showTopDismissButton: {
      type: Boolean,
      default: false,
    },
    topDismissButtonLabel: {
      type: String,
      default: 'x',
    },
    topDismissButtonClass: {
      type: String,
      default: 'close'
    },
    isCloseButtonBusy: {
      type: Boolean,
      default: false,
    },
    isCloseButtonDisabled: {
      type: Boolean,
      default: false,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    showBottomCloseButton: {
      type: Boolean,
      default: true,
    },
    bottomCloseButtonLabel: {
      type: String,
      default: 'OK',
    },
    bottomCloseButtonClass: {
      type: String,
      default: 'btn-primary',
    },
    showBottomCloseButtonIcon: {
      type: Boolean,
      default: false,
    },
    bottomCloseButtonIconClass: {
      type: String,
      default: 'fa-trash',
    },
    showBottomDismissButton: {
      type: Boolean,
      default: true,
    },
    bottomDismissButtonLabel: {
      type: String,
      default: 'キャンセル',
    },
    flipBottomButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldCloseButtonDisabled() {
      return this.isCloseButtonBusy || this.isCloseButtonDisabled
    }
  },
  data() {
    return {
      modalBodyMaxHeight: 350,
    }
  },
  mounted() {
    const windowH = window.innerHeight
    const dialogOffsetTop = this.$refs.modalDialog.offsetTop
    let modalHeaderH = 0
    let modalFooterH = 0
    if (this.$refs.modalHeader) {
      modalHeaderH = this.$refs.modalHeader.clientHeight
    }
    if (this.$refs.modalFooter) {
      modalFooterH = this.$refs.modalFooter.clientHeight
    }
    this.modalBodyMaxHeight =
      windowH - modalHeaderH - modalFooterH - dialogOffsetTop * 2
  },
}
</script>

<style lang="scss" scoped>
  .modal-container {
    font-size: 18px;
  }
  .modal {
    display: block;
  }
  .modal-dialog {
    min-width: 45%;
    height: 92%;
    max-height: 92%;
    .p1 {
      margin: 0 0 4px 0;
    }
    .p2 {
      margin: 20px 0 8px;
    }
  }
  @media only screen and (min-width: 1280px) {
    .modal-dialog {
      max-width: 600px;
      min-width: 600px;
    }
  }
  .modal-header {
    padding: 6px 10px;
    align-items: center;
    .title {
      margin: 6px 0;
    }
  }
  .modal-body {
    overflow-y: scroll;
  }
  .modal-footer {
    display: block;
    padding: 0.8rem 1rem;
    text-align: right;
  }

  .modal-backdrop {
    opacity: 0.5;
  }

  .modal-enter {
    opacity: 0;
  }
  .modal-enter-active {
    transition: opacity .0s ease;
  }
  .modal-enter-to {
    opacity: 1.0;
  }
  .modal-leave-active {
    opacity: 0;
  }
</style>
